const bodyStyleTypes = [
    {
        type: 'sedan',
        CODES: ['SD'],
    },
    {
        type: 'coupe',
        CODES: ['CP'],
    },
    {
        type: 'hatchback',
        CODES: ['HB'],
    },
    {
        type: 'van',
        CODES: ['WG', 'MV'],
    },
    {
        type: 'convertible',
        CODES: ['CT'],
    },
    {
        type: 'suv',
        CODES: ['SV', 'CO'],
    },
    {
        type: 'pickup',
        CODES: ['PK', 'HP', 'CC'],
    },
    {
        type: 'commercial',
        CODES: ['CV', 'OT'],
    },
    {
        type: 'passengervan',
        CODES: ['PV'],
    },
    {
        type: 'crewvan',
        CODES: ['WV'],
    },
    {
        type: 'wagon',
        CODES: ['WG'],
    },
    {
        type: 'minivan',
        CODES: ['MV'],
    },
    {
        type: 'hybrid',
        CODES: ['HE'],
    },
];

export default bodyStyleTypes;
